<template>
  <div :id="id" :class="className" ref="echarts" :style="{ height: height, width: width }" />
</template>

<script>
const echarts = require("echarts");

export default {
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "pie-chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    option: {
      type: Array,
      default:[0,0]
    },
    type:String,
    unit:String
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    let self = this
    let myChart = echarts.init(this.$refs.echarts);
        this.myChart = myChart;
        let option = {
            xAxis: {
                type: "category",
                data: ["本期", this.type=='chain'?'上期':"同期"],
                axisLabel:{
                    fontSize:12,
                    color: "#333",
                    fontWeight:'bold'
                }
            },
            tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
                // position:"inside",
                textStyle: {
                  color: "#333333", //设置文字颜色
                  align:"left"
                },
                position: function (point, params, dom, rect, size) {
                    // 固定在顶部
                    return ['10%', point[1]];
                },
                formatter: function (params) {
                  let str = ``;
                  params.forEach((item, idx) => {
                    let unit = self.unit
                    str += `${item.marker} ${item.name}: <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> ${unit}</b>`
                    str += idx === params.length -1? '': '<br/>'
                  })
                  return str
                }
            },
            
            title: {
              text: this.unit,
              textAlign:"left",
              left: -5,// 距离左边位置
              // top: -5,// 距离上面位置
              textStyle:{
                align:"left",
                fontWeight:'bold',
                fontSize:12,
                color: "#333",
                fontStyle:'italic'
              }
            },
            yAxis: {
                type: "value",
                // name:this.unit,
                nameTextStyle: {
                    align: "right",
                    fontWeight:'bold',
                    fontStyle:"italic",
                    color: "#333",
                },
                splitLine:{
                    show:true,
                    lineStyle:{
                        type:'dashed',
                    }
                },
                axisLabel:{
                    fontSize:12,
                    color: "#333",
                    fontWeight:'bold'
                }
            },
            grid: {
                left: "0%",
                right: "10%",
                bottom: "1%",
                top: "10%",
                containLabel: true,
            },
            series: [
                {
                data: [
                    {
                    value: this.option[1].toFixed(2),
                    itemStyle: {
                        color: "#5B8FF9",
                    },
                    },
                    {
                    value: this.option[0].toFixed(2),
                    itemStyle: {
                        color: "#5AD8A6",
                    },
                    },
                ],
                type: "bar",
                },
            ],
        };
        this.myChart.setOption(option,true);

        window.addEventListener("resize", () => {
            this.myChart.resize();
        });
  },
  methods: {
    
  },
  watch: {
    option: function(newData, oldData) {
      this.myChart.clear()
        let option = {
            xAxis: {
                type: "category",
                data: ["本期", "同期"],
            },
            tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
            },
            yAxis: {
                type: "value",
                // max:function(value) {
                //     return value.max*2
                // }
            },
            grid: {
                left: "0%",
                right: "10%",
                bottom: "1%",
                top: "10%",
                containLabel: true,
            },
            series: [
                {
                data: [
                    {
                    value: this.option[1].toFixed(2),
                    itemStyle: {
                        color: "#5B8FF9",
                    },
                    },
                    {
                    value: this.option[0].toFixed(2),
                    itemStyle: {
                        color: "#5AD8A6",
                    },
                    },
                ],
                type: "bar",
                },
            ],
        };
		this.myChart.setOption(option,true);
    },
  },
};
</script>
